import React, { useContext, useState } from 'react'
import { Button, Col, Logo, Row } from 'react-angle-dashboard-components'
import { Dropdown } from 'react-bootstrap'
import { LayoutContext } from '../../context/layout'
import { Header } from './style'
import { ILinkItem, NavbarDropdownKey, NavbarMenuItem } from '../../interfaces'

let timeOutId: any = {
  aboutUs: undefined,
  login: undefined,
  whoWeServe: undefined
}

export const Navbar: React.FC = () => {
  const { navMenu: menuLinks } = useContext(LayoutContext)
  const [show, setShow] = useState<NavbarDropdownKey | 'idle'>('idle')

  const showDropdown = (type: NavbarDropdownKey) => {
    clearTimeout(timeOutId[type])
    setShow(type)
  }
  const hideDropdown = (type: NavbarDropdownKey) => {
    timeOutId[type] = setTimeout(
      () => setShow((s) => (s === type ? 'idle' : s)),
      300
    )
  }

  return (
    <Header>
      <div className="w-75">
        <Row className="w-100 pt-2">
          <span role="button">
            <Logo color="primary" size="lg" />
          </span>
          <Col className="d-none d-lg-flex align-items-center justify-content-around">
            {menuLinks.map((dropdownItem: NavbarMenuItem) => {
              return (
                <Dropdown
                  show={show === dropdownItem.key}
                  onMouseEnter={() => showDropdown(dropdownItem.key)}
                  onMouseLeave={() => hideDropdown(dropdownItem.key)}
                >
                  <Dropdown.Toggle
                    variant="light"
                    style={{ background: 'transparent', border: 'none' }}
                    className="px-0 mr-3 text-dark"
                    id="dropdown-log-in"
                  >
                    <div className="w-100 text-dark font-weight-bold">
                      {dropdownItem.text}
                    </div>
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="w-100 py-0 shadow rounded">
                    {dropdownItem.dropdownLinks.map(
                      (linkItem: ILinkItem, i) => (
                        <Dropdown.Item
                          key={i}
                          className="mt-0 ml-0 mb-0 text-center px-3"
                        >
                          <p
                            className="text-dark font-weight-bold fs-16 d-block py-1 mb-0"
                            onClick={() => window.open(linkItem.link, '_blank')}
                          >
                            {linkItem.text}
                          </p>
                        </Dropdown.Item>
                      )
                    )}
                  </Dropdown.Menu>
                </Dropdown>
              )
            })}
            <Button
              className="fs-16 font-weight-bold px-5 py-2"
              style={{ borderRadius: '50px' }}
              href="https://www.anglehealth.com/network-directories"
              target="_blank"
            >
              Find my Doctor
            </Button>
          </Col>
        </Row>
      </div>
    </Header>
  )
}
